module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 387
// module chunks = 0